import { call, put, select } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import { wiredDevicesSelector } from 'selectors'
import { CHANGE_WIRED_DEVICE_TYPE } from 'actions/entityActionTypes'
import { updateWiredDeviceAction } from 'actions/entityActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

export function * changeWiredDeviceType(action) {
  try {
    const { id, newType } = yield action
    const { wiredDevices } = yield select(wiredDevicesSelector)
    const currentWiredDevice = wiredDevices[id]

    if (!currentWiredDevice) return

    if (currentWiredDevice.nameTouched) return yield put(updateWiredDeviceAction(id, { type: newType }))

    const typeCount = Object.values(wiredDevices).filter(device => device.type === newType).length + 1
    yield put(updateWiredDeviceAction(id, { type: newType, name: `${newType} ${typeCount}` }))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchChangeWiredDeviceType() {
  yield * takeEvery(CHANGE_WIRED_DEVICE_TYPE, changeWiredDeviceType)
}



// WEBPACK FOOTER //
// ./src/sagas/changeWiredDeviceTypeSaga.js